import React from 'react'

import type { IconProps } from './types'

const ExternalUrl: React.FC<IconProps> = ({
  size = 24,
  color = '#595959',
  ...rest
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.68301 13.3168C2.91634 13.5501 3.20139 13.6668 3.53814 13.6668H12.4612C12.7979 13.6668 13.083 13.5501 13.3163 13.3168C13.5496 13.0835 13.6663 12.7984 13.6663 12.4617V8.75656C13.6663 8.61469 13.6184 8.49589 13.5227 8.40016C13.427 8.30444 13.3082 8.25658 13.1663 8.25658C13.0244 8.25658 12.9056 8.30444 12.8099 8.40016C12.7142 8.49589 12.6663 8.61469 12.6663 8.75656V12.4617C12.6663 12.513 12.645 12.56 12.6022 12.6027C12.5595 12.6454 12.5125 12.6668 12.4612 12.6668H3.53814C3.48685 12.6668 3.43984 12.6454 3.39709 12.6027C3.35436 12.56 3.33299 12.513 3.33299 12.4617V3.53863C3.33299 3.48734 3.35436 3.44032 3.39709 3.39758C3.43984 3.35485 3.48685 3.33348 3.53814 3.33348H7.24324C7.38512 3.33348 7.50392 3.28562 7.59964 3.1899C7.69536 3.09417 7.74323 2.97537 7.74323 2.8335C7.74323 2.69162 7.69536 2.57282 7.59964 2.4771C7.50392 2.38136 7.38512 2.3335 7.24324 2.3335H3.53814C3.20139 2.3335 2.91634 2.45016 2.68301 2.6835C2.44967 2.91683 2.33301 3.20187 2.33301 3.53863V12.4617C2.33301 12.7984 2.44967 13.0835 2.68301 13.3168ZM6.83042 9.87193L12.6663 4.03603V6.16683C12.6663 6.30871 12.7142 6.42751 12.8099 6.52323C12.9056 6.61895 13.0244 6.66681 13.1663 6.66681C13.3082 6.66681 13.427 6.61895 13.5227 6.52323C13.6184 6.42751 13.6663 6.30871 13.6663 6.16683V2.3335H9.83298C9.6911 2.3335 9.5723 2.38136 9.47657 2.4771C9.38085 2.57282 9.33299 2.69162 9.33299 2.8335C9.33299 2.97537 9.38085 3.09417 9.47657 3.1899C9.5723 3.28562 9.6911 3.33348 9.83298 3.33348H11.9638L6.12787 9.16938C6.0313 9.26596 5.98301 9.38305 5.98301 9.52066C5.98301 9.65826 6.0313 9.77535 6.12787 9.87193C6.22445 9.96851 6.34261 10.0157 6.48236 10.0136C6.62209 10.0115 6.73811 9.96424 6.83042 9.87193Z"
        fill={color}
      />
    </svg>
  )
}

export default ExternalUrl
